//
// turbofunctions() v 3.0
//

import './mu-functions.js'

const isString = (value) => typeof value === 'string' || value instanceof String
const isObject = obj => obj !== null && typeof obj === 'object' && !Array.isArray(obj)

function preventEventDefaults(e) {
	if (!e) {
		e = window.event;
	}
	if (e.preventDefault) {
		e.preventDefault();
	}
	e.returnValue = false;
}

// getSTP() == Scroll from Top Position
function getSTP() {
	var d = document.documentElement,
		st = (window.pageYOffset || d.scrollTop) - (d.clientTop || 0);
	return parseInt(st)
}

const requestAnimationFrame = (f) => {
	return (
		window.requestAnimationFrame(f) ||
		window.mozRequestAnimationFrame(f) ||
		window.webkitRequestAnimationFrame(f) ||
		window.msRequestAnimationFrame(f) ||
		function(f) {
			return setTimeout(f, 1000 / 60)
		}
	)
} 

const cancelAnimationFrame = (f) => {
	return (
		window.cancelAnimationFrame(f) || 
		// window.webkitCancelAnimationFrame(f) || 
		// window.webkitCancelRequestAnimationFrame(f) || 
		// window.mozCancelAnimationFrame(f) || 
		function(f) {
			clearTimeout(f)
		}
	)
}

const mouseWheel = /Firefox/i.test(navigator.userAgent) ? 'DOMMouseScroll' : 'mousewheel'

const addEventListener = (element, type, callback) => {
	if (element.addEventListener) {
		element.addEventListener(type, callback, false);
	} else if (element.attachEvent) {
		element.attachEvent('on' + type, callback);
	}
};

Element.prototype.setProperty = function(property, value) {
	this.style.setProperty('-webkit-' + property, value);
	this.style.setProperty('-moz-' + property, value);
	this.style.setProperty('-ms-' + property, value);
	this.style.setProperty('-o-' + property, value);
	this.style.setProperty(property, value);
	return this;
}

Element.prototype.removeProperty = function(property) {
	this.style.removeProperty('-webkit-' + property);
	this.style.removeProperty('-moz-' + property);
	this.style.removeProperty('-ms-' + property);
	this.style.removeProperty('-o-' + property);
	this.style.removeProperty(property);
	return this;
}

const transform = (element, prop) => {
	element.style.transform = prop
	element.style.OTransform = prop // Opera
	element.style.msTransform = prop // IE 9
	element.style.MozTransform = prop // Firefox
	element.style.WebkitTransform = prop // Safari and Chrome
}

Element.prototype.transform = function(prop) {
	return transform(this, prop)
}

const checkCursor = (e) => {
	if (e.type == 'mousedown') {
		var e = e;
	} else if (e.touches) {
		var e = e.touches[0];
	}
	return { x: e.clientX, y: e.clientY }
};

// document.getElementById('single_content').offset().top
Element.prototype.offset = function() {
	var _t, top, left, height, width, obj;
	_t = this.getBoundingClientRect()
	top = getSTP() + _t.top
	left = _t.left
	height = _t.height
	width = _t.width
	obj = {
		'top': parseInt(top),
		'left': parseInt(left),
		'width': parseInt(width),
		'height': parseInt(height)
	}
	return obj
}

// String.concatString(newString)
String.prototype.concatString = function(value) {
	if (!value) return this
	if (typeof value === 'number' || 'boolean') value = String(value);
	if (value.length == 0) return this

	var c = this,
		attr, attr_l,
		add_value, add_value_l,
		c_new = '',
		space;

	if (!c || c.length === 0) {
		c_new = value
	} else {

		attr = c.split(' ');
		attr_l = attr.length;
		add_value = value.split(' ');
		add_value_l = add_value.length;

		for (var i = 0; i < attr_l; i++) {
			for (var a = 0; a < add_value_l; a++) {
				if (attr[i] === add_value[a]) {
					attr.splice(i, 1);
					// return
				}
			}
		}

		attr = attr.concat(add_value);
		attr_l = attr.length;

		for (var i = 0; i < attr_l; i++) {
			space = ' ';
			if (i === attr_l - 1) space = '';
			c_new += attr[i] + space;
		}
	}

	return c_new;
}

String.prototype.removeFrom = function(value) {
	if (!value) return ''
	if ( !isString(value) ) console.error('String.removeFrom( attribute shuld be a string )')

	const c = this
	let c_new = '',
		filteredList;

	if (!c || c.length === 0) {
		c_new = value
	} else {
		let list = value.split(' '),
			rmList = c.split(' ');

		filteredList = list.filter( elem => rmList.filter( rmElem => elem.indexOf(rmElem) == -1 && elem ).length > 0 )
	}

	c_new = filteredList.join(' ')

	return c_new
}

// element.hasAttr('class', 'active')
// will not add indexed value cuz its already indexed, make array
Element.prototype.hasAttr = function(attribute, thisValue) {
	var c = this.getAttribute(attribute);
	if (c) {
		if (!thisValue && thisValue !== false) {
			return true
		}  else if (typeof thisValue === 'boolean') {
			return thisValue
		} else {
			thisValue = String(thisValue);
		
			var arr = c.split(' '),
				arr_l = arr.length;
			thisValue = thisValue.replace(/\s+/g, '');

			for (var i = 0; i < arr_l; i++) {
				if (thisValue, arr[i] === thisValue) {
					return true;
				} else if (i == arr_l - 1) {
					return false;
				}
			}
		}
	} else {
		return false;
	}
}

// element.addAttr('attrname', 'attrvalue')
// no style support
Element.prototype.addAttr = function(attribute, thisValue = false) {
	if (typeof thisValue === 'number' || 'boolean')  thisValue = thisValue.toString();
	
	var c = this.getAttribute(attribute),
		attr, attr_l,
		add_value, add_value_l,
		c_new = '',
		space;

	if (!c || c.length === 0) {
		this.setAttribute(attribute, thisValue)
	} else {

		attr = c.split(' ');
		attr_l = attr.length;
		add_value = thisValue.split(' ');
		add_value_l = add_value.length;

		for (var i = 0; i < attr_l; i++) {
			for (var a = 0; a < add_value_l; a++) {
				if (attr[i] === add_value[a]) {
					// attr.splice(i, 1);
					return
				}
			}
		}

		attr = attr.concat(add_value);
		attr_l = attr.length;

		for (var i = 0; i < attr_l; i++) {
			space = ' ';
			if (i === attr_l - 1) space = '';
			c_new += attr[i] + space;
		}
		// console.log(
		// 	attr, '\n',
		// 	add_value, '\n',
		// 	c_new
		// );

		this.setAttribute(attribute, '');
		if (c_new) this.setAttribute(attribute, c_new)
	}

	return this;
}

// element.rmAttr('attrname', 'attrvalue attrvalue2 attrvalue3')
Element.prototype.rmAttr = function(attribute, thisValue) {
	var c = this.getAttribute(attribute),
		attrArr, attrArrLen,
		rmValueArr,
		c_new = '';
	if (c) {
		if (!thisValue) {
			this.removeAttribute(attribute);
		} else {
			let spliced = false;

			attrArr = c.split(' ');
			rmValueArr = thisValue.split(' ');
			attrArr.map( ( attr, i ) => {
				rmValueArr.map( value => {
					if ( attr === value ) {
						attrArr.splice(i, 1)
						spliced = true
					}
				})
			})

			if ( !spliced ) return
			
			attrArrLen = attrArr.length;
			attrArr.map( ( attr, i ) => {
				c_new += attr + `${ i === attrArrLen - 1 ? '' : ' '}`
			})

			this.setAttribute(attribute, '');
			if (c_new) this.setAttribute(attribute, c_new)
		}
	} else {
		this.removeAttribute(attribute);
	}

	return this;
}

// element.addClass('classvalue')
Element.prototype.addClass = function(thisValue) {
	this.addAttr('class', thisValue);
	return this;
}

// element.rmClass('classvalue')
Element.prototype.rmClass = function(thisValue) {
	this.rmAttr('class', thisValue);
	return this;
}

// element.getClosest('.class')
Element.prototype.getClosest = function(selector) {
	let elem = this
	while (elem) {
		if ( elem === document.documentElement ) return false
		if ( elem.parentNode.querySelector(selector) ) return elem
		elem = elem.parentNode
	}
	return false
}

const elementInWindow = element => {
	return getSTP() + window.innerHeight > parseInt(element.offset().top) && getSTP() + window.innerHeight < parseInt(element.offset().top) + window.innerHeight + parseInt(element.offsetHeight)
}

export {
	addEventListener, 
    checkCursor, 
    preventEventDefaults, 
    requestAnimationFrame, 
    cancelAnimationFrame,
    mouseWheel,
    elementInWindow,
	isString,
	isObject
}